const prefix = 'Dashboard/Menu'

export const ITEMS_ADD = `${prefix}/ITEMS_ADD`
